export default __webpack_public_path__ + "static/media/youtube.1f4a5600.png";